import React, { useState, useEffect } from 'react';
import axiosInstance from '../../axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

const SupportServices = ({ onClose }) => {
    const [currentView, setCurrentView] = useState('chat'); // default to 'chat'
    const [email, setEmail] = useState('');
    const [supportTier, setSupportTier] = useState('');
    const [currentStatus, setCurrentStatus] = useState(null); // Track current status (support active or not)
    const [isLoading, setIsLoading] = useState(false);
    const [formMode, setFormMode] = useState('enable'); // 'enable' or 'disable'


    // Fetch status when email changes
    useEffect(() => {
        if (email.trim() && email.includes('@')) {
            setIsLoading(true);
            axiosInstance.get(`${API_URL}/users/support-services?email=${encodeURIComponent(email)}`)
                .then(response => setCurrentStatus(response.data))
                .catch(() => setCurrentStatus(null))
                .finally(() => setIsLoading(false));
        }
    }, [email]);

    // Auto-submit when both fields are valid
    useEffect(() => {
        if (email.trim() && supportTier.trim() && !isLoading) {
            handleAutoSubmit();
        }
    }, [email, supportTier, isLoading]);

    const handleAutoSubmit = async () => {
        try {
            const response = await axiosInstance.post(
                `${API_URL}/users/support-services`, 
                { email, supportTier }
            );
            // Show success but don't alert (non-intrusive)
            setCurrentStatus({
                support: true,
                tier: supportTier
            });
        } catch (error) {
            console.error('Auto-submit failed:', error);
        }
    };

    const handleDisableSupport = async () => {
        if (!email.trim() || !email.includes('@')) return;
        setIsLoading(true);
        try {
            const response = await axiosInstance.delete(`${API_URL}/users/support-services`, {
                data: { email } // Pass email in the request body
            });
    
            if (response?.data?.message) {
                alert(`Success: ${response.data.message}`);
            } else {
                alert('Support disabled successfully.');
            }
    
            setCurrentStatus({
                support: false,
                tier: null
            });
        } catch (error) {
            console.error('Failed to disable support:', error);
    
            if (error.response?.data?.message) {
                alert(`Error: ${error.response.data.message}`);
            } else {
                alert('An error occurred while disabling support.');
            }
        } finally {
            setSupportTier('');
            setEmail('');         // <--- CLEAR EMAIL after sending, no matter success or error
            setIsLoading(false);
        }
    };
    

    useEffect(() => {
        if (
            formMode === 'disable' &&             // Only in disable mode
            email.trim() &&                       // Email must be non-empty
            email.includes('@') &&                // Email must look valid
            !isLoading &&                         // Not already submitting
            currentStatus?.support !== false      // Only disable if support isn't already disabled
        ) {
            handleDisableSupport();
        }
    }, [email, formMode, isLoading, currentStatus]);
    

    return (
        <div className='register-Deliverable'>
            <div>
                <button
                    className="close-button"
                    onClick={() => {
                        onClose();
                        setCurrentView('chat');         // Reset to default view
                        setEmail('');
                        setSupportTier('');
                        setCurrentStatus(null);
                    }}
                >
                    x
                </button>
                <div className="toggle-buttons">
    {currentView === 'Support Services' ? (
        <>
            <button
                className={`toggle-button ${formMode === 'enable' ? 'active' : ''}`}
                onClick={() => setFormMode('enable')}
            >
                Enable Support
            </button>
            <button
                type="button"
                className={`toggle-button ${formMode === 'disable' ? 'active' : ''}`}
                onClick={() => setFormMode('disable')}
            >
                Disable Support
            </button>
        </>
    ) : (
        <>
            <button
                className={`toggle-button ${currentView === 'chat' ? 'active' : ''}`}
                onClick={() => {
                    setCurrentView('chat');
                    setCurrentStatus(null);
                }}
            >
                Chat Now
            </button>
            <button
                className="toggle-button"
                onClick={() => {
                    setCurrentView('Support Services');
                    setFormMode('enable'); // Default to enable form first
                }}
            >
                Enable Support
            </button>
        </>
    )}
</div>


                <div className='popup-content'>
                    <div className='mini_container'>
                        {/* Render Support Services Form */}
                        {currentView === 'Support Services' ? (
    <form id="register-form" onSubmit={(e) => e.preventDefault()}>
        <input
            type="email"
            name="email"
            placeholder="Enter user email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
        />

        {/* Only render extra fields if enabling support */}
        {formMode === 'enable' && (
            <>
                {isLoading ? (
                    <div className="status-loading">Checking status...</div>
                ) : currentStatus ? (
                    <div className="current-status">
                        <h4>Current Support:</h4>
                        <p>• Tier: {currentStatus.tier || 'None'} {currentStatus.support ? '🟢' : '🔴'}</p>
                    </div>
                ) : null}

                <select
                    name="supportTier"
                    value={supportTier}
                    onChange={(e) => setSupportTier(e.target.value)}
                    required
                >
                    <option value="" disabled>Select tier</option>
                    <option value="Support Ticket">Basic Support ($8.99/mo)</option>
                    <option value="Standard Support">Live Chat ($16.25/mo)</option>
                    <option value="Premium Support">Premium ($99/mo)</option>
                </select>

                {email && supportTier && (
                    <div className="auto-submit-feedback">
                        ✔️ Changes saved automatically
                    </div>
                )}
            </>
        )}
    </form>
) : (
    <a href="https://1498.3cx.cloud/#/chat" target="_blank" rel="noopener noreferrer">
        Live Chat
    </a>
)}

                    </div>
                </div>
            </div>
        </div>
    );
};

export default SupportServices;
